

import Button from '@/ui-kit/components/button';
import { StyleColorSchemeType, StyleSizeType } from '@/ui-kit/styles/enums';
import { ModalPositionType, ModalSlotName } from '@/ui-kit/components/modal/enums';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import ModalService from '@/ui-kit/components/modal/ModalService';
import SearchFiltersEvents from '../../mixins/SearchFiltersEvents';
import SearchFiltersMobileModal from './modal';

export default {
  name: 'SearchFiltersMobile',
  components: {
    Button,
  },
  mixins: [SearchFiltersEvents],
  props: {
    filters: {
      default: () => ({}),
      type: Object,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      StyleSizeType,
      StyleColorSchemeType,
      ModalPositionType,
      ModalSlotName,
      ButtonFillType,
    };
  },
  methods: {
    async handleFiltersButtonClick() {
      const filters = await this.openFilters();

      if (!filters) {
        return;
      }

      this.emitChange(filters);
    },
    openFilters() {
      return ModalService.open({
        component: SearchFiltersMobileModal,
        data: {
          filters: this.filters,
          resetFilters: () => this.emitReset(),
        },
      });
    },
  },
};
